import classNames from 'classnames';
import format from 'date-fns/format';
import * as React from 'react';
import { useIntl } from 'react-intl';
import LabeledContainer from '../../../../common/LabeledContainer';
import PurchaseItemProfile from '../PurchaseItemList/PurchaseItemProfile';

import css from '../PurchaseItemList/PurchaseItemList.module.scss';

interface OwnProps {
  productImage?: string;
  merchantId?: string;
  productName?: string;
  name?: string;
  price: number;
  ticketCount?: number;
  expiryDate?: string;
}

type Props = OwnProps;

const PurchaseTicketBookItemList = ({
  ticketCount,
  price,
  expiryDate,
  ...props
}: Props) => {
  const classes = classNames(css.PurchaseItemList);
  const intl = useIntl();

  return (
    <LabeledContainer
      label={intl.formatMessage({
        id: `purchases.purchaseItemList.title.ticketBook`,
      })}
      paddingTop={true}
    >
      <div className={classes}>
        <PurchaseItemProfile
          productImage={props.productImage}
          productName={props.productName}
          merchantId={props.merchantId}
          schemeType="ticketBook"
        />
        <dl className={css.PurchaseItemList__List}>
          <dt className={css.PurchaseItemList__ListTitle}>
            {intl.formatMessage({ id: 'common.totalPrice' })}
          </dt>
          <dd className={css.PurchaseItemList__ListData} data-style="price">
            {intl.formatMessage(
              { id: 'common.price' },
              { price: intl.formatNumber(price) },
            )}
          </dd>
        </dl>
        {ticketCount && (
          <dl className={css.PurchaseItemList__List}>
            <dt className={css.PurchaseItemList__ListTitle}>
              {intl.formatMessage({ id: 'common.validCount' })}
            </dt>
            <dd
              className={css.PurchaseItemList__ListData}
              data-style="table-child"
            >
              {intl.formatMessage(
                { id: 'common.ticketCount' },
                { ticketCount: intl.formatNumber(ticketCount) },
              )}
            </dd>
          </dl>
        )}
        {expiryDate && (
          <dl className={css.PurchaseItemList__List}>
            <dt className={css.PurchaseItemList__ListTitle}>
              {intl.formatMessage({ id: 'common.expiryDate' })}
            </dt>
            <dd
              className={css.PurchaseItemList__ListData}
              data-style="table-child"
            >
              {intl.formatDate(format(expiryDate), {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'short',
              })}
            </dd>
          </dl>
        )}
        <dl className={css.PurchaseItemList__List}>
          <dt className={css.PurchaseItemList__ListTitle}>
            {intl.formatMessage({ id: 'common.paymentMethod' })}
          </dt>
          <dd
            className={css.PurchaseItemList__ListData}
            data-style="table-child"
          >
            {intl.formatMessage({ id: 'common.creditCard' })}
          </dd>
        </dl>
      </div>
    </LabeledContainer>
  );
};

export default PurchaseTicketBookItemList;
